import React, { Component } from 'react';
import logo from '../img/logo-inverted.png';

class Logo extends Component {
  render () {
    return (
      <a href="https://ibankcoin.com">
        <img alt="iBankCoin" style={{height: '30px', margin: '0 auto'}} src={logo} />
      </a>
    );
  }
}

export default Logo;



/** WEBPACK FOOTER **
 ** ./src/components/Logo.js
 **/